module.exports = __webpack_public_path__ + "img/7_Whats wrong with you Gülcan.59170df1.jpg";